<app-breadcrumb [breadcrumb]="'Login'" [title]="'Login'"></app-breadcrumb>
<!-- section start -->
<section class="login-page section-b-space">
    <div class="container">
        <div class="row">
            <div class="col-lg-6">
                <h3>Login</h3>
                <div class="theme-card">
                    <form #loginForm="ngForm" (ngSubmit)="loginForm.valid && login()" class="theme-form">
                        <div class="form-group">
                            <label for="email">Email</label>
                            <input #userName="ngModel" [(ngModel)]="loginRequest.userName" class="form-control"
                                   id="email"
                                   name="userName" placeholder="Email" required type="text">
                            <div *ngIf="userName.errors && (userName.dirty || userName.touched || loginForm.submitted)">
                <span [hidden]="!userName.errors.required" class="text-danger">
                  This field is required.
                </span>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="review">Password</label>
                            <input #password="ngModel" [(ngModel)]="loginRequest.password" class="form-control"
                                   id="review"
                                   name="password" placeholder="Enter your password" required type="password">
                            <div *ngIf="password.errors && (password.dirty || password.touched || loginForm.submitted)">
                <span [hidden]="!password.errors.required" class="text-danger">
                  This field is required.
                </span>
                            </div>
                        </div>
                        <div class="form-group">
                            <span class="text-danger">{{errorMessage}}</span>
                        </div>
                        <button class="btn btn-solid" type="submit">Login</button>
                    </form>
                </div>
            </div>
            <div class="col-lg-6 right-login">
                <h3>New Customer</h3>
                <div class="theme-card authentication-right">
                    <h6 class="title-font">Create A Account</h6>
                    <p>Sign up for a free account at our store. Registration is quick and easy. It allows you to be able
                        to order
                        from our shop. To start shopping click register.</p>
                    <button [routerLink]="['/register']" class="btn btn-solid">Create an Account</button>
                </div>
            </div>
        </div>
    </div>
</section>
<!--Section ends-->
